var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article-content"},[_c('h2',{staticClass:"article-content__title"},[_vm._v(_vm._s(_vm.data.title))]),_c('div',{staticClass:"article-content__body",domProps:{"innerHTML":_vm._s(_vm.data.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61dccc04","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Article/components/article-content.vue
// module id = 1209
// module chunks = 1